/* eslint-disable import/prefer-default-export */
import { ExtendableError } from '@/classes/Errors/ExtendableError';

export class AuthorizationError extends ExtendableError {}
